module.exports = __webpack_public_path__ + "c_static/img/2-3天猫-收藏店铺.9408247.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-3天猫-收藏店铺.jpg
// module id = d4nr
// module chunks = 33